import { openConsentBanner } from '../../../../../assets/private/js/cookieConsent';

const TOGGLER_SELECTOR = '.js-cookiebot-toggler';

document.addEventListener('click', event => {
  const toggler = event.target.closest ? event.target.closest(TOGGLER_SELECTOR) : null;

  if (!toggler) return;

  event.preventDefault();

  if (!openConsentBanner()) {
    console.warn('CookiebotToggler: Cookiebot is not available');
  }
});
